/**
 * Accepts a bare embed URL or a full <iframe ... src="..."> snippet from env.
 * Returns the dashboard URL only, or undefined if none could be derived.
 */
export const HARPWOOD_PHONE_CALLS_DASHBOARD_URL =
  'https://app.powerbi.com/view?r=eyJrIjoiNzFmNWQyYzEtOGIwOS00ZTIwLTgxZjMtMGZmYTU5MDM3ZjEwIiwidCI6ImUzNmQ3NWZhLWU4NjItNDAyMC05MzllLTU0YjFiNDQ2NGFlMSJ9';

export function parsePhoneCallsDashboardUrl(raw: string | undefined): string | undefined {
  if (raw == null) return undefined;
  const trimmed = raw.trim();
  if (!trimmed) return undefined;

  const srcMatch = trimmed.match(/\bsrc\s*=\s*["']([^"']+)["']/i);
  if (srcMatch?.[1]) {
    const fromIframe = srcMatch[1].trim();
    if (fromIframe) return fromIframe;
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return undefined;
}

export function getPhoneCallsDashboardUrl(): string {
  return (
    parsePhoneCallsDashboardUrl(process.env.REACT_APP_PHONE_CALLS_DASHBOARD_URL) ??
    HARPWOOD_PHONE_CALLS_DASHBOARD_URL
  );
}
